module.exports = __webpack_public_path__ + "img/Folded_Paper_case_thumbnail_Newschain.cf6aef10.jpg";